// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__QmjMT","productName":"Table_productName__8XR_m"};